<v-public-bottom-gradient-wrapper>
  <div
    class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative max-w-[480px]">
    <v-public-logo-header
      [header]="'pages.recover.header' | transloco"
      [subheader]="
        'pages.recover.subheader' | transloco
      "></v-public-logo-header>

    <v-card variant="glass-v2" padding="lg">
      <div slot="body">
        @if (stage === 'confirm-code') {
          <div class="vops-krator-recovery mt-4">
            @if (recoveryFlow()) {
              <app-kratos-form-v2
                #kf
                [flow]="recoveryFlow()"
                (submitFlow)="submitFlow($event)"
                [renderFallback]="false">

                @if (kf.hasMessages()) {
                  <ng-template vKfName="messages"></ng-template>
                }

                <div class="flex flex-col gap-4">
                  @if (kf.isVisible('code-input-email')) {
                    <div class="col-span-1">
                      <ng-template [vKfName]="'code-input-email'"></ng-template>
                    </div>
                  }

                  @if (kf.isVisible('code-input-code')) {
                    <div class="col-span-1">
                      <ng-template [vKfName]="'code-input-code'"> </ng-template>
                    </div>
                  }

                  @if (kf.isVisible('code-input-method-code')) {
                    <div class="col-span-1">
                      <ng-template [vKfName]="'code-input-method-code'">
                      </ng-template>
                    </div>
                  }
                </div>
              </app-kratos-form-v2>
            }
          </div>
        }

        @if (stage === 'reset-password') {
          <div class="vops-krator-recovery mt-6">
            @if (settingsFlow()) {
              <app-kratos-form-v2
                #kf
                [flow]="settingsFlow()"
                [renderFallback]="false"
                (submitFlow)="submitSettingsFlow($event)">
                <div class="flex flex-col gap-4">
                  @if (kf.isVisible('password-input-password')) {
                    <div class="col-span-1">
                      <ng-template
                        [vKfName]="'password-input-password'"></ng-template>
                    </div>
                  }

                  @if (kf.isVisible('password-input-method-password')) {
                    <div class="col-span-1">
                      <ng-template
                        [vKfName]="
                          'password-input-method-password'
                        "></ng-template>
                    </div>
                  }
                </div>
              </app-kratos-form-v2>
            }
          </div>
        }
      </div>
    </v-card>
    <div class="text-center text-subtle">
      {{ 'pages.recover.needHelp' | transloco }}
      <a
        href="https://incidite.com/contact"
        target="_blank"
        class="text-primary font-bold"
        >{{ 'pages.recover.contactUs' | transloco }}</a
      >
    </div>
  </div>
</v-public-bottom-gradient-wrapper>
